// removed by extract-text-webpack-plugin
module.exports = {"breadcrumbs":"_1dCzi","hideOnMobile":"_1f4Lv","links":"vXqfi","link":"_20G1p","delimiter":"R-J5p","filter":"_3IIdm","active":"_3GZeo","helperText":"A1yll"};


//////////////////
// WEBPACK FOOTER
// ./banquet/components/Breadcrumbs/index.sass
// module id = 1465
// module chunks = 1